import { Routes } from '@angular/router';

export const accountRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('@rma/accounts/activation'),
  },
  {
    path: '',
    loadChildren: () => import('@rma/accounts/member-invitation'),
  },
  {
    path: '',
    loadChildren: () => import('@rma/accounts/login'),
  },
  {
    path: 'unsubscribe/:emailId',
    loadComponent: () => import('@rma/accounts/unsubscribe'),
  },
];
